<template>
  <div>
    <section class="section section-lg pt-0 mt-3">
      <div class="container">
        <div class="justify-content-center">
          <picture>
            <source :srcset="require('../assets/images/about-1080.webp')" media="(min-width: 721px)" />
            <source :srcset="require('../assets/images/about-720.webp')" media="(min-width: 413px)" />
            <img 
              :src="require('../assets/images/about-412.webp')"
              style="width: 100%;"
              alt="Lote agrícola con sierras de fondo"
              class="about-us-img mt-3"
            />
          </picture>
        </div>
        <div class="row mt-3">
          <div class="col-lg-12 text-center">
            <h1 class="about-us-title mt-4" style="font-size: 32px;">Sobre nosotros</h1>
            <p class="about-us-text mt-3">Sabemos el<strong> dolor que genera tener que alquilar un lote </strong>para la próxima
              campaña y lo difícil que es conseguir algo de calidad y a buen precio.
              Es por eso que creamos LotePerfecto, una plataforma inteligente que encuentra
              el lote que estás buscando en segundos y al mejor precio.<br><br>

              Combinamos información histórica de millones de parámetros del lote con
              inteligencia artificial para crear el<strong> match perfecto entre un productor y
              un lote</strong>. Así, hemos logrado sacar una gran preocupación de la mente de los
              productores ayudándolos a encontrar el terreno perfecto para su producción,
              mejorando así la calidad y rendimiento de su producción.<br><br>

              En LotePerfecto creemos en la importancia del trabajo en equipo y la colaboración
              con nuestros clientes para así lograr los mejores resultados. Nuestro objetivo es
              que encuentres el mejor terreno para tu producción, y estar ahí para ayudarte en cada
              paso del camino. <br><br>

              Si estás en busca del lote ideal para tu próxima campaña, no dudes en contactarnos,
              ¡el match perfecto puede ser más fácil de lo que piensas!</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  mounted() {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'pageview',
        'page_location': '/about',
        'page_title': 'AboutUs'
    });
  }
}
</script>